import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import SectionWrapper from 'ferries/Home/components/SectionWrapper';
import Button from 'helpers/Button';
import LazyImage from 'helpers/LazyImage';
import {replaceAssetsImgUrl} from 'cms/helpers/common';
import {MOBILE_WIDTH, TABLET_WIDTH} from 'helpers/stableValues';

const sliderSettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 5,
  arrows: true,
  responsive: [{
    breakpoint: TABLET_WIDTH,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  }, {
    breakpoint: MOBILE_WIDTH,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }]
};

const TrustedPartners = ({companyPartners}) => {
  const {title, subtitle, description, url, companies, trs} = companyPartners;

  return (
    <SectionWrapper title={title} subtitle={subtitle} description={description}>
      <div className="bg-snow rounded p-2">
        <Slider {...sliderSettings}>
          {
            companies.map(({ID, post_title, image, permanlink}) =>
              <a key={ID ?? post_title} href={permanlink} target="_blank" rel="noreferrer">
                <LazyImage
                  wrapperClass="p-2"
                  imgClass="w-1-1"
                  src={replaceAssetsImgUrl(image)}
                  width="100%"
                  height="100%"
                  title={post_title}
                  alt={post_title}
                />
              </a>
            )
          }
        </Slider>
      </div>
      {url && <div className="text-center mt-3"><Button
        outline
        status="primary"
        target="_blank"
        rel="noreferrer"
        href={url}
      >
        {trs.companiesLink}
      </Button></div>}
    </SectionWrapper>
  );
};

TrustedPartners.propTypes = {
  companyPartners: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    url: PropTypes.string,
    companies: PropTypes.array.isRequired,
    trs: PropTypes.shape({
      companiesLink: PropTypes.string.isRequired
    })
  })
};

export default TrustedPartners;
